import { ChangeDetectionStrategy, Component, input } from '@angular/core';
/**
 * Shared layout for displaying error pages.
 *
 * Supports an optional message and can vertically center the content when needed.
 */
@Component({
    selector: 'apcam-error-page',
    templateUrl: './error-page.component.html',
    styleUrl: './error-page.component.scss',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent {
    readonly title = input.required<string>();
    readonly message = input<string>();
    readonly centered = input<boolean>(false);
}
